import React, { useState, useEffect } from 'react';
import { DateRangePicker, CustomProvider } from 'rsuite';
import dayjs from 'dayjs';
import { Box } from '@mui/material';

// Ensure the CSS is loaded
import enUS from 'rsuite/locales/en_US';
import 'rsuite/dist/rsuite-no-reset.min.css';

const RangeFilter = ({ dateRange, setDateRange, width = 230, ranges = [], weekStart = 0 }) => {
  const defaultRanges = [
    {
      label: 'This Week',
      value: [dayjs().startOf('week').toDate(), dayjs().toDate()]
    },
    {
      label: 'Last Week',
      value: [
        dayjs().subtract(1, 'week').startOf('week').toDate(),
        dayjs().subtract(1, 'week').endOf('week').toDate()
      ]
    },
    {
      label: 'This Month',
      value: [dayjs().startOf('month').toDate(), dayjs().toDate()]
    },
    {
      label: 'Last Month',
      value: [
        dayjs().subtract(1, 'month').startOf('month').toDate(),
        dayjs().subtract(1, 'month').endOf('month').toDate()
      ]
    }
  ];

  const resolvedRanges = ranges?.length > 0 ? ranges : defaultRanges;

  // Use a local state for the UI to handle the 'half-selected' state smoothly
  const [tempValue, setTempValue] = useState(null);

  // Sync local UI value with parent props
  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      setTempValue([
        dayjs(dateRange.startDate).toDate(),
        dayjs(dateRange.endDate).toDate()
      ]);
    } else {
      setTempValue(null);
    }
  }, [dateRange]);

  const handleOnChange = (val) => {
    setTempValue(val); // Update local UI immediately

    if (!val) {
      setDateRange({ startDate: null, endDate: null });
    } else if (val[0] && val[1]) {
      // Only update the parent state when BOTH dates are selected
      setDateRange({
        startDate: dayjs(val[0]).startOf('day'),
        endDate: dayjs(val[1]).endOf('day')
      });
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      // Ensure RSuite popup overlays MUI dialogs and popovers
      '& .rs-picker-popup.rs-picker-popup-daterange': { zIndex: 14000 }
    }}>
      <CustomProvider locale={enUS} weekStart={weekStart}>
        <DateRangePicker
          format="MMM dd, yyyy"
          character=" - "
          placeholder="Select Date Range"
          value={tempValue}
          onChange={handleOnChange}
          shouldDisableDate={(date) => dayjs(date).isAfter(dayjs(), 'day')}
          cleanable={true}
          preventOverflow={true}
          oneTap={false}
          container={typeof document !== 'undefined' ? document.body : undefined}
          popupStyle={{ zIndex: 14000 }}
          style={{ width: width }}
          ranges={resolvedRanges}
        />
      </CustomProvider>
    </Box>
  );
};

export default RangeFilter;